module.exports = __webpack_public_path__ + "img/icon-facebook.37a38c6d.svg";